import { Banners } from "modules/banners";

const BannersPage = () => {
  return <Banners />;
};

export default BannersPage;
